$(document).ready(function () {
    $('#error_explanation').on('click', function () {
        $(this).fadeOut(500);
    });
});
